/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Permission_Name_Contactcodes_WriteInputs */

const en_enum_permission_name_contactcodes_write = /** @type {(inputs: Enum_Permission_Name_Contactcodes_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Contactcodes Write`)
};

const de_enum_permission_name_contactcodes_write = /** @type {(inputs: Enum_Permission_Name_Contactcodes_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Contactcodes Write`)
};

/**
* | output |
* | --- |
* | "Name Contactcodes Write" |
*
* @param {Enum_Permission_Name_Contactcodes_WriteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_permission_name_contactcodes_write = /** @type {((inputs?: Enum_Permission_Name_Contactcodes_WriteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Permission_Name_Contactcodes_WriteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_permission_name_contactcodes_write(inputs)
	return de_enum_permission_name_contactcodes_write(inputs)
});